<div class="migrations-container">
  <ziro-breadcrumbs><ziro-breadcrumb-card-item [aboutCardId]="96"></ziro-breadcrumb-card-item></ziro-breadcrumbs>

  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  } @else {
    <ziro-datatable
      [class]="'ziro-card'"
      [columns]="columns"
      [rowDataSource]="tableRows"
      [uniqueRowIdentifier]="'name'"
      [dataAutomation]="tableDataAutomation"
      [mainFilterPlaceholder]="'tkey;migrations.cisco.auto_attendants.table.filter.placeholder' | translate"
      [showCustomAlert]="showCustomAlert"
    >
      <ziro-datatable-multi-select-filter
        [label]="'tkey;migrations.cisco.auto_attendants.table.type'"
        [items]="typeFilterOptions"
        [matchFn]="typeMatchFn"
        [dataAutomation]="'auto-attendant-type-filter'"
        [tableId]="tableDataAutomation"
      ></ziro-datatable-multi-select-filter>

      <ziro-datatable-multi-select-filter
        #complexityFilter
        [label]="'tkey;migrations.cisco.auto_attendants.table.complexity'"
        [items]="complexityFilterOptions"
        [matchFn]="complexityMatchFn"
        [dataAutomation]="'auto-attendant-complexity-filter'"
        [tableId]="tableDataAutomation"
        (isInitialized)="onFilterInitialized()"
      ></ziro-datatable-multi-select-filter>

      <div class="text-center" alert-content>
        {{ 'tkey;admin.ziro_reports.auto_attendants.datatable.error_1' | translate }}
        <button class="btn btn-border btn-link strong" (click)="onRefreshClick()">
          {{ 'tkey;admin.ziro_reports.auto_attendants.datatable.error_2' | translate }}
        </button>
        {{ 'tkey;admin.ziro_reports.auto_attendants.datatable.error_3' | translate }}
      </div>
    </ziro-datatable>
  }
</div>
